import { ChangeDetectionStrategy, Component, ElementRef, effect, inject, viewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { AvIntakeLoaderComponent } from '../av-intake-loader/av-intake-loader.component';
import { BlockingWaitFacade } from '../../../../Facades/blocking-wait.facade';
import { waitState } from '../../Services/wait-state.util';

@Component({
  selector: 'av-blocking-veil',
  standalone: true,
  imports: [TranslateModule, AvIntakeLoaderComponent],
  templateUrl: './av-blocking-veil.component.html',
  styleUrl: './av-blocking-veil.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvBlockingVeilComponent {
  private readonly _blockingWait = inject(BlockingWaitFacade);
  private readonly _dialog = viewChild.required<ElementRef<HTMLDialogElement>>('dialog');

  protected readonly wait = waitState(this._blockingWait.busy, { grace: 120 });

  constructor() {
    this._registerDialogSync();
  }

  protected onDialogCancel(event: Event): void {
    event.preventDefault();
  }

  private _registerDialogSync(): void {
    effect(() => {
      const dialog = this._dialog().nativeElement;

      if (this._blockingWait.busy()) {
        if (!dialog.open) {
          dialog.showModal();
        }
        return;
      }

      if (dialog.open) {
        dialog.close();
      }
    });
  }
}
